(function () {
    "use strict";

    const initFloatingElements = () => {
        const floatingElements = document.querySelectorAll(".negarshop-floating-element");

        floatingElements.forEach(el => {
            const triggerType = el.getAttribute("data-trigger-type") || "onload";

            const showFloating = () => {
                el.classList.remove("ns-float-trigger-hidden");
            };

            const hideFloating = () => {
                el.classList.add("ns-float-trigger-hidden");
            };

            // Set up triggers
            if (triggerType === "onload") {
                const delay = parseInt(el.getAttribute("data-trigger-delay") || "0", 10) * 1000;
                if (delay > 0) {
                    setTimeout(showFloating, delay);
                } else {
                    showFloating();
                }
            } else if (triggerType === "scroll") {
                const triggerScroll = el.getAttribute("data-trigger-scroll") || "50";

                const onScroll = () => {
                    let shouldTrigger = false;

                    // Check if numeric (percentage) or selector
                    if (!isNaN(triggerScroll)) {
                        const percent = parseInt(triggerScroll, 10);
                        const scrollTop = window.scrollY || document.documentElement.scrollTop;
                        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
                        const currentPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
                        if (currentPercent >= percent) {
                            shouldTrigger = true;
                        }
                    } else {
                        // Selector
                        try {
                            const target = document.querySelector(triggerScroll);
                            if (target) {
                                const rect = target.getBoundingClientRect();
                                if (rect.top <= window.innerHeight && rect.bottom >= 0) {
                                    shouldTrigger = true;
                                }
                            }
                        } catch (e) {
                            // Invalid selector
                        }
                    }

                    if (shouldTrigger) {
                        showFloating();
                    } else {
                        hideFloating();
                    }
                };

                window.addEventListener("scroll", onScroll);
                // Call once in case they are already scrolled past
                onScroll();
            }
        });
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initFloatingElements);
    } else {
        initFloatingElements();
    }
})();
